<template>
  <!-- /*Breadcrums*/ -->
  <div class="row">
    <div class="col-sm-8" id="breadcrums">
      <p>
        <template v-for="(crumb, index) in crumbParts" :key="index">
          <span class="crumb-item">{{ crumb }}</span>
          <span v-if="index < crumbParts.length - 1" class="crumb-sep" aria-hidden="true"></span>
        </template>
      </p>
    </div>
    <div class="col-sm-1"></div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'bread-crumb',
  props: {
    crumbs: String
  },
  created() {
    this.breadCrumbs = this.crumbs
  },
  watch: {
    crumbs(val, old) {
      if(val!=='') {
        this.breadCrumbs = val
      }
      else {
        this.breadCrumbs = old
      }
    }
  },
  computed: {
    crumbParts() {
      return (this.breadCrumbs || '').split(' > ').filter(c => c.trim());
    }
  },
  data() {
    return {
      breadCrumbs: this.crumbs
    }
  }
});

</script>

<style scoped>
#breadcrums p {
  font-weight: 600;
  font-size: 0.85rem;
  letter-spacing: 0.01em;
}

.crumb-item {
  font-weight: 600;
}

.crumb-sep {
  display: inline-block;
  width: 0.42rem;
  height: 0.42rem;
  margin: 0 0.5rem;
  border-top: 2px solid currentColor;
  border-right: 2px solid currentColor;
  vertical-align: middle;
  position: relative;
  top: -1px;
  transform: rotate(45deg);
  opacity: 0.8;
}
</style>
